
// export const baseURL = "http://192.168.29.80:8000/";
export const baseURL = "https://admin.freshbells.in/public/";

